<template>
    <tr :class="isContactFormOpen || isDeleteRequested ? 'edit-row' : ''">
        <td>
            <EmptyTextHandler :text="contact.firstName" />
        </td>
        <td>
            <EmptyTextHandler :text="contact.lastName" />
        </td>
        <td>
            <EmptyTextHandler :text="roleValues" />
        </td>
        <td>
            <EmptyTextHandler :text="relationshipValue" />
        </td>
        <td>
            <EmptyTextHandler :text="primaryPhoneNumber" />
        </td>
        <td class="text-center" v-if="!isDeleteRequested && !isPalliative">
            <i v-if="contact.isEmergencyContact" class="fas fa-check-circle text-success"></i>
            <i v-else class="fa fa-times-circle text-danger"></i>
        </td>
        <td class="text-center" v-if="!isDeleteRequested && isPalliative">
            <i v-if="contact.isPrimaryEmergencyContact" class="fas fa-check-circle text-success"></i>
            <i v-else class="fa fa-times-circle text-danger"></i>
        </td>
        <td class="text-center" v-if="!isDeleteRequested && isPalliative">
            <i v-if="contact.isEmergencyContact" class="fas fa-check-circle text-success"></i>
            <i v-else class="fa fa-times-circle text-danger"></i>
        </td>
        <td class="text-center" v-if="!isDeleteRequested && !isPalliative">
            <i v-if="contact.isCahpsSurveyRecipient" class="fas fa-check-circle text-success"></i>
            <i v-else class="fa fa-times-circle text-danger"></i>
        </td>
        <td class="text-center" v-if="!isDeleteRequested">
            <i v-if="contact.isBereavedContact" class="fas fa-check-circle text-success"></i>
            <i v-else class="fa fa-times-circle text-danger"></i>
        </td>
        <td class="text-end" v-if="!isContactFormOpen && !isDeleteRequested && !isReOrderRequested">
            <button type="button" class="btn table-btn btn-outline-info" @click="showContactForm(true)">
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="requestDeleteContact()"
                tooltip="title: Delete Contact"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <td class="text-end" v-if="isReOrderRequested">
            <button
                type="button"
                class="btn table-btn btn-outline-info"
                tooltip="title: Move Contact Up"
                @click="moveUp(contact.contactOrder)"
                v-if="contact.contactOrder !== 0"
            >
                <i class="fas fa-chevron-circle-up"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-info"
                tooltip="title: Move Contact Down"
                @click="moveDown(contact.contactOrder)"
                v-if="contact.contactOrder !== totalContacts - 1"
            >
                <i class="fas fa-chevron-circle-down"></i>
            </button>
        </td>
        <td class="text-end" v-if="isContactFormOpen">
            <i class="fw-bold"> {{ isEditRequested ? "Editing In Progress" : "View In Progress" }} </i>
        </td>
        <td colspan="4" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteContact"
                :cancel="cancelDeleteContact"
            />
        </td>
    </tr>

    <!-- Editing -->
    <tr v-if="isContactFormOpen" class="edit-row">
        <td :colspan="columns" class="p-3">
            <PatientAuthorizedContactsForm
                :is-loading="isSaving"
                :relationships-enum="relationshipsEnum"
                :contact-roles-enum="contactRolesEnum"
                :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                :is-palliative="isPalliative"
                :contact="contactCopy"
                :patient-primary-address="patientPrimaryAddress"
                :is-editable="isEditRequested"
                :patient-id="patientId"
                :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                :close-contact-form="closeContactForm"
                :refresh-list="refreshList"
            />
            <footer class="d-flex justify-content-center" v-if="!isSaving">
                <button type="button" class="btn btn-primary me-2 mb-2" @click="saveContact()">Save</button>
                <button type="button" class="btn btn-outline-primary mb-2" @click="closeContactForm()">Cancel</button>
            </footer>
        </td>
    </tr>
</template>

<script lang="ts" src="./PatientAuthorizedContactsRow.ts"></script>
